import { DotSvg } from "../../assets/svg";

interface PendingTaskCardProps{
  cardTitle: string;
  pendingTask: {
    title: string,
    type: string
  }[];
}

function PendingTaskCard({...props}:PendingTaskCardProps) {
  return(
    <div className='polymer-pending-task-card'>
      <p className='polymer-pending-task-card__title'>
        {props.cardTitle}
      </p>
      <div className='polymer-pending-task-card__content'>
        {
          props.pendingTask.map((task,_index) => {
            const key = _index;

            return(
              <div className='polymer-pending-task-card__content-item' key={key}>
                {DotSvg()}
                <span>{task.title}</span>
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default PendingTaskCard